import React, { useEffect, useRef, useState } from 'react';
import { Button } from 'components'
import useApp from 'hooks/useApp'
import styles from '../index.module.css'
import { selectedOrgsState, certTypeState } from '../states'
import { useRecoilValue } from 'recoil';
import useCertifications from 'hooks/useCertifications'

const TransmitRequest2 = () => {

	const App = useApp()
	const mounted = useRef()
	const selectedOrgs = useRecoilValue(selectedOrgsState)
	const certType = useRecoilValue(certTypeState)
	const [buttonText, setButtonText] = useState("아래로 내려보기")
	const [atBottom, setAtBottom] = useState(false)
	const { goCommonCert, goNaverCert, goIndividualCert } = useCertifications()
	const core = useRef()

	const onNext = () => {
		if (atBottom) {
			switch (certType) {
				case 0: // 공동인증
					goCommonCert()
					break
				case 1: // 네이버인증
					goNaverCert()
					break
				case 2: // 사설인증
					goIndividualCert()
					break
			}
		} else {
			const scrollTop = core.current.scrollTop
			const pageHeight = document.body.scrollHeight
			core.current.scrollTo(0, (scrollTop + pageHeight) * 0.8)
		}
	}

	const bindScroll = () => {
		core.current = document.querySelector(".core")
		if (core.current.clientHeight >= core.current.scrollHeight - 30) {
			setAtBottom(true)
		}
		core.current.addEventListener("scroll", e => {
			const clientHeight = core.current.clientHeight
			const scrollHeight = core.current.scrollHeight
			const scrollTop = core.current.scrollTop
			if (!mounted.current) return
			if (clientHeight + scrollTop >= scrollHeight - 30) {
				setAtBottom(true)
			} else {
				setAtBottom(false)
			}
		})
	}

	useEffect(() => {
		if (atBottom) {
			setButtonText("동의하기")
		} else {
			setButtonText("아래로 내려보기")
		}
	}, [atBottom])

	useEffect(() => {
		mounted.current = true
		App.setHeader({
			show: true,
			title: <></>,
			left: undefined,
			right: undefined
		})

		App.setShowNav(false)
		App.setMainClass("white")

		mounted.current && bindScroll()

		console.log({ certType })

		return () => mounted.current = false
	}, [])

	return (
		<div className="page">
			<div className="shadow">
				<div className="padding">
					<div className={styles["count-group"]}>
						<p>전송요구 및 정보 제공 동의</p>
						<div><span>3</span>/3</div>
					</div>
					<div className={`${styles["terms-area"]} mt_40`}>
						<p>개인(신용)정보 제공 동의서</p>
						<span className="mt_10">
							귀하는 개인(신용)정보 제공에 관한 동의를 거부하실 수 있습니다. 다만, 개인(신용) 정보의 제공에 관한 동의는 본인신용정보 통합조회, 데이터분석 서비스, 마이데이터 서비스 가입현황 안내 및 전송요구내역 통합조회 서비스 이용과 직접적으로 관련된 필수적 사항이므로 아래의 사항에 동의하셔야만 본인신용정보 통합조회, 데이터분석 서비스, 마이데이터서비스 가입현황 안내 및 전송요구내역 통합조회 서비스의 제공이 가능합니다.
						</span>
						<ul className="mt_40">
							<li>
								<div>제공받는 자</div>
								<p className="text-blue mt_10">
									{
										selectedOrgs &&
										selectedOrgs.map((item, index) => {
											return <span className="ml_5" key={index}>{item.insttNm}{index < selectedOrgs.length - 1 && ", "}</span>
										})
									}
								</p>
							</li>
							<li>
								<div>제공받는 자의 이용목적</div>
								<p className="text-blue mt_10">본인확인 및 개인(신용)정보의 전송</p>
							</li>
							<li>
								<div>보유 및 이용기간</div>
								<p className="text-blue mt_10">본인확인 및 개인(신용)정보의 전송 목적 달성 시까지</p>
							</li>
							<li>
								<div>제공항목</div>
								<span>
									전자서명, CI, 인증서, 전송요구서
								</span>
							</li>
						</ul>
					</div>
				</div>
			</div>
			<div className="padding">
				<div className={`${styles["terms-area"]} pb_100`}>
					<ul>
						<li>
							<div>제공받는 자</div>
							<p className="text-blue mt_10">한국신용정보원</p>
						</li>
						<li>
							<div>제공받는 자의 이용목적</div>
							<p className="text-blue mt_10">마이데이터서비스 가입현황 안내 및 전송요구내역 통합조회 서비스 제공</p>
						</li>
						<li>
							<div>보유 및 이용기간</div>
							<p className="text-blue mt_10">한국신용정보원의 마이데이터서비스 가입현황 안내 및 전송요구내역 통합조회 서비스 목적 달성 시까지</p>
						</li>
						<li>
							<div>제공항목</div>
							<span>회원 가입여부, 서비스목록수, 서비스목록, 클라이언트ID, 전송요구내역수, 전송요구내역목록, 정보제공자 기관코드, 권한 범위, 전송요구일자, 전송요구종료시점</span>
						</li>
					</ul>
					<p className="mt_40">위 개인(신용)정보 제공에 동의하십니까?</p>
				</div>
			</div>
			{/* 스크롤 끝 까지 내려가면 가이드 텍스트 사라지고 버튼명 동의하기로 변경 */}
			<div className={`${styles["floating-btn"]} padding`}>
				<div className="flex-justify_center mb_20">
					<span className={styles.guide}><i className="icon icon_floating_arrow_down mr_5" />끝까지 확인하고 동의하기</span>
				</div>
				<Button className="btn btn--big" onClick={onNext}>{buttonText}</Button>
			</div>
		</div>
	)
}

export default TransmitRequest2